import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './DIDServices.css';

const DIDServices = () => {
  return (
    <div className="didservices-container">
      {/* Hero Section */}
      <section className="didservices-hero">
        <motion.div 
          className="didservices-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="didservices-hero-title">DID Services</h1>
          <h2 className="didservices-hero-subtitle">
            Enhance Your Business Communication with Reliable, Scalable DID Solutions
          </h2>
          <Link to="/contact" className="didservices-cta-btn">
            <motion.button
              className="didservices-cta-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Get Started
            </motion.button>
          </Link>
        </motion.div>
      </section>

      {/* Main Content */}
      <section className="didservices-content">
        <div className="didservices-content-container">
          <motion.div 
            className="didservices-intro"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2 className="didservices-section-title">Direct Inward Dialing (DID) Services</h2>
            <p className="didservices-section-text">
              Welcome to DirectRoutes Networks' DID Services, your gateway to reliable, scalable, and cost-effective inbound calling solutions.
            </p>
          </motion.div>

          <motion.div 
            className="didservices-main-content"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <p className="didservices-section-text">
              Our robust Direct Inward Dialing (DID) platform ensures seamless SIP-based call delivery with extensive nationwide coverage. Whether you are expanding operations or launching a new initiative, we provide access to a broad selection of local and toll-free numbers across major U.S. markets. This empowers you to create a customer-centric communication strategy that evolves alongside your business.
            </p>
          </motion.div>

          <motion.div 
            className="didservices-conclusion"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            <p className="didservices-section-text">
              As a trusted leader in telecom innovation, DirectRoutes Networks delivers inbound call solutions that combine performance, reliability, and flexibility. Partner with us to ensure your business remains seamlessly connected, highly responsive, and competitively positioned in today's dynamic market.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default DIDServices;
